// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saved-lists-grid-container {
  display: grid;
  width: 60vw;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 14px;
  grid-template-columns: 150px 200px 90px 90px 170px 100px 60px 1fr;
}
.saved-lists-grid-container .saved-lists-grid-header {
  font-size: 14px;
  font-weight: bold;
  color: #6A8991;
  padding: 10px 10px 10px 20px;
  -webkit-user-select: none;
          user-select: none;
  border-bottom: 1px solid #C3C8CA;
}
.saved-lists-grid-container .saved-lists-grid-cell {
  font-size: 14px;
  font-weight: bold;
  color: #062229;
  padding: 10px 10px 10px 20px;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
}
.saved-lists-grid-container .saved-lists-grid-link {
  color: blue;
  cursor: pointer;
}
.saved-lists-grid-container .saved-lists-grid-long {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
}

.saved-list-confirm-container {
  width: 400px;
  background-color: #E6E9EA;
  padding: 20px 30px;
  border-radius: 15px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/SavedListsTable/SavedListsTable.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iEAAA;AACD;AACC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gCAAA;AACF;AAEC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAGC;EACC,WAAA;EACA,eAAA;AADF;AAIC;EACC,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAMA;EACC,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAHD","sourcesContent":[".saved-lists-grid-container {\n\tdisplay: grid;\n\twidth: 60vw;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tfont-size: 14px;\n\tgrid-template-columns: 150px 200px 90px 90px 170px 100px 60px 1fr;\n\n\t.saved-lists-grid-header {\n\t\tfont-size: 14px;\n\t\tfont-weight: bold;\n\t\tcolor: #6A8991;\n\t\tpadding: 10px 10px 10px 20px;\n\t\tuser-select: none;\n\t\tborder-bottom: 1px solid #C3C8CA;\n\t}\n\n\t.saved-lists-grid-cell {\n\t\tfont-size: 14px;\n\t\tfont-weight: bold;\n\t\tcolor: #062229;\n\t\tpadding: 10px 10px 10px 20px;\n\t\tuser-select: none;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\t\n\t.saved-lists-grid-link {\n\t\tcolor: blue;\n\t\tcursor: pointer;\n\t}\n\n\t.saved-lists-grid-long {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tpadding-right: 10px;\n\t}\n}\n\n.saved-list-confirm-container {\n\twidth: 400px;\n\tbackground-color: #E6E9EA;\n\tpadding: 20px 30px;\n\tborder-radius: 15px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
